const config = {
  // LOCAL
  restApiUri: 'http://localhost:3001/api',
  activityFeedUri: 'ws://localhost:3002',

  // restApiUri: 'https://cloud.hey.space:3001/api',
  // activityFeedUri: 'wss://cloud.hey.space:3002',

  // LOCAL
  // restApiUri: 'http://192.168.1.12:3001/api',
  // activityFeedUri: 'ws://192.168.1.12:3002',

  // TUNNEL
  // restApiUri: 'http://cb.heyspace.info/api',
  // activityFeedUri: 'ws://cb.heyspace.info/feed',

  // PROD
  // restApiUri: "https://app.hey.space/api",
  // activityFeedUri: "wss://app.hey.space/feed",

  activityFeedReconnectionDelay: 5000,
  googleClientId: '980452382491-akebdelqbqc2aul3eo050g9cj5gu2elr.apps.googleusercontent.com',
  sentryDSN: 'https://d3a5fe7eba304fb282fe0feab0229758@sentry.timecamp.io/6',
  customerMessagingPlatformApiKey: 'cP1y8m',
  isTrackingEnabled: true,
  amazonResizeUrl: 'https://tocpjptk01.execute-api.eu-central-1.amazonaws.com/dev/resize?key=',
  landingPageUrl: 'https://timecamp.com/planner',
  fcm: {
    senderID: '980452382491',
    androidChannelId: 'heyspace',
    androidChannelName: 'Heyspace',
    vapidKey: 'BGYmlaG2aAeVC2yAZFg_58ZLPRiKxuDTDv4TQan_HKh3ZjN4xZlrPuHqPcIue-9JBI2QnKSM6oH7Z7H2dzLgwrA',
    apiKey: 'AIzaSyCa-zKCkdexo1TZg3AFmo1BuIHq_ogfwOk',
    authDomain: 'heyspace-dce00.firebaseapp.com',
    databaseURL: 'https://heyspace-dce00.firebaseio.com',
    projectId: 'heyspace-dce00',
    storageBucket: 'heyspace-dce00.appspot.com',
    appId: '1:980452382491:web:c50b5560a17909f6d865be',
  },
  payment: { site: 'test-timecamp-test' },
};

window.__tc3_config = config;
